import { render } from "./CheckboxBlockListOpenableField.vue?vue&type=template&id=7e561ad6"
import script from "./CheckboxBlockListOpenableField.vue?vue&type=script&lang=js"
export * from "./CheckboxBlockListOpenableField.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__